import { render } from "./AlertNotifikation.vue?vue&type=template&id=1c387466&scoped=true"
import script from "./AlertNotifikation.vue?vue&type=script&lang=js"
export * from "./AlertNotifikation.vue?vue&type=script&lang=js"

import "./AlertNotifikation.vue?vue&type=style&index=0&id=1c387466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c387466"]])

export default __exports__